// @flow
import * as React from 'react';
import Icon from '../../../components/shared/Icons/Icon';
import styles from './styles';

type Props = {
  name: string,
  options: Object,
  selectedOption?: ?string | number,
  size?: ?string,
  placeholder?: ?string,
  markAsActive?: ?string | number | boolean,
  placeholderValue?: string | number,
  style?: ?Object,
  optionsSorted?: ?boolean,
  onChange: Function,
};

function sortByLocaleLanguage(textA: string, textB: string) {
  return textA.localeCompare(textB);
}

function Select({
  name,
  selectedOption,
  size,
  onChange,
  placeholder,
  placeholderValue,
  options,
  style,
  markAsActive,
  optionsSorted,
}: Props): React.Node {
  const optionsKeys = optionsSorted
    ? Object.keys(options).sort((a, b) => sortByLocaleLanguage(options[a], options[b]))
    : Object.keys(options);

  const isDisabled = optionsKeys.length === 0;
  const appliedClassName = markAsActive ? 'isActive' : null;

  return (
    <span
      className={`select ${size || ''} ${isDisabled ? 'disabled' : ''} ${appliedClassName || ''}`}
      style={style}
    >
      <select
        name={name}
        id={name}
        value={selectedOption || 0}
        onChange={onChange}
        disabled={isDisabled}
      >
        {placeholder && <option value={placeholderValue}>{placeholder}</option>}
        {optionsKeys.map(keyName => (
          <option key={keyName} value={keyName}>
            {options[keyName]}
          </option>
        ))}
      </select>
      <span className="arrow">
        <Icon type="arrow-down" width={19} />
      </span>
      <style jsx>{styles}</style>
    </span>
  );
}

Select.defaultProps = {
  selectedOption: undefined,
  placeholder: null,
  markAsActive: null,
  placeholderValue: '',
  size: 'medium',
  style: null,
  optionsSorted: false,
};

export default Select;



// WEBPACK FOOTER //
// ./app/common/forms/Select/index.js